export default __webpack_public_path__ + "static/media/Required_Icon.947513af.svg";